import { useEffect, useState } from "react"

const usePlanFilters = ({ selectedPlan }) => {
  const initialFilter = selectedPlan?.isSubscription
    ? selectedPlan.instalments
    : 2

  const [activeFilter, setActiveFilter] = useState(initialFilter)

  useEffect(() => {
    if (selectedPlan?.isSubscription) {
      setActiveFilter(selectedPlan.instalments)
    }
  }, [selectedPlan])

  return {
    activeFilter,
    setActiveFilter,
  }
}

export default usePlanFilters
